// src/components/DepositCard.jsx
import React from 'react';
import './DepositCard.css';
import Button from './Button';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const DepositCard = ({ title, loading, depositDetails, onPayment, t }) => {
  return (
    <div className="card-deposit">
      {title && <h2 className="card-deposit-title">{title}</h2>}
      {loading || !depositDetails ? (
        <div className="card-deposit-skeleton">
          <Skeleton height={30} width={200} style={{ marginBottom: "10px" }} />
          <Skeleton height={40} width={100} style={{ marginBottom: "10px" }} />
          <Skeleton height={20} width={150} style={{ marginBottom: "5px" }} />
          <Skeleton height={20} width={100} style={{ marginBottom: "5px" }} />
          <Skeleton height={20} width={120} style={{ marginBottom: "10px" }} />
        </div>
      ) : (
        <div className="card-deposit-details">
          <p className="card-deposit-info">
            {t("checkout.referenceLabel")} {depositDetails.depositId}
          </p>
          <p className="card-deposit-amount">
            {depositDetails.depositAmount} €
          </p>
          <p className="card-deposit-requestedby-label">
            {t("checkout.requestedByLabel")}
          </p>
          <p className="card-deposit-requestedby">
            {depositDetails.ownerLabel}
          </p>
        </div>
      )}
      <div className="card-deposit-cta">
        <Button
          label={loading ? t("checkout.loading") : t("checkout.cta")}
          onClick={onPayment}
          disabled={loading || !depositDetails}
          type="button"
        />
      </div>
    </div>
  );
};

export default DepositCard;
